import { Button } from "@/components/ui/button"
import FeedbackRatingButtons from "./feedback-rating-buttons"

interface FlashcardDeckFooterProps {
  isLoading: boolean
  isSuccess: boolean
  isError: boolean
  showAnswer: boolean
  onClickRating: (confidence: number) => void
  onClickShowAnswer: () => void
}

export default function FlashcardDeckFooter({
  isLoading,
  isSuccess,
  showAnswer,
  onClickRating,
  onClickShowAnswer,
}: FlashcardDeckFooterProps) {
  return (
    <footer className="flex h-fit w-full items-end justify-center">
      {showAnswer ? (
        <FeedbackRatingButtons
          isSuccess={isSuccess}
          isLoading={isLoading}
          onClick={onClickRating}
        />
      ) : (
        <Button size="lg" onClick={onClickShowAnswer}>
          Mostrar respuesta
        </Button>
      )}
    </footer>
  )
}
